import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Auth0Provider
    domain="dev-6suzj3kcj7xwvpm7.us.auth0.com"
    clientId="B8LaA2zvwDdKqheivCt23R9kXmdkrSPx"
    authorizationParams={{
      redirect_uri: `${window.location.origin}/callback`
    }}
  >
    <App />
  </Auth0Provider>
);